
import { defineComponent, PropType } from 'vue'

import UploadedFile from '@/modules/InvoiceModule/components/UploadedFile/index.vue'

export default defineComponent({
    components: {
        UploadedFile
    },
    props: {
        invoiceFiles: {
            type: Array as PropType<File[]>,
            default: () => []
        },
        certificateFiles: {
            type: Array as PropType<File[]>,
            default: () => []
        }
    }
})
